





































































































































































import Vue from "vue";
import { Component, Inject, Watch } from "vue-property-decorator";
import moment from "moment";
import { GridOptions } from "ag-grid-community";
import { RestClient } from "@elite/restclient";
import { ISelectListItem } from "@everbright/promotions/lib/models";
import { AjaxDataSource, DefaultGridOptions, initializeTable } from "../table";
import { IOrderHistoryModel } from "../models";

@Component
export default class OrderHistoryGrid extends Vue {
    @Inject()
    restClient!: RestClient;

    // Default current dates to today
    fromDate: string = moment()
        .startOf("day")
        .format(moment.HTML5_FMT.DATETIME_LOCAL_SECONDS);
    toDate: string = moment()
        .endOf("day")
        .format(moment.HTML5_FMT.DATETIME_LOCAL_SECONDS);

    campaignCodes: ISelectListItem[] | null = null;
    campaignOptions: ISelectListItem[] = [];

    promotionCodes: ISelectListItem[] | null = null;
    promotionOptions: ISelectListItem[] = [];

    gridOptions: GridOptions = new DefaultGridOptions(
        undefined,
        true,
        false,
        false,
        250
    );
    dataSource!: AjaxDataSource<IOrderHistoryModel>;

    get excelReportUrl(): string {
        const apiUrl: string = process.env.VUE_APP_API_BASE_URL;
        const token = this.$store.state.token;
        const baseUrl = `${apiUrl}api/OrderHistoryGrid/Export?fromOrderDate=${this.fromDate}&toOrderDate=${this.toDate}&token=${token}`;
        let campaignUrl = "";
        let promotionUrl = "";
        if (this.campaignCodes)
            for (const campaignCode of this.campaignCodes) {
                campaignUrl += `&campaignCodes=${campaignCode.value}`;
            }
        if (this.promotionCodes)
            for (const promotionCode of this.promotionCodes) {
                promotionUrl += `&promotionCodes=${promotionCode.value}`;
            }
        return `${baseUrl}${campaignUrl}${promotionUrl}`;
    }

    mounted(): void {
        this.dataSource = new AjaxDataSource<IOrderHistoryModel>(
            this.restClient,
            "/api/OrderHistoryGrid",
            this.additionalData,
            this.gridOptions.api || undefined
        );

        initializeTable(
            this.gridOptions,
            this.dataSource,
            undefined,
            this,
            false
        );

        this.getAdvantageCampaignItems();
    }

    additionalData(): Record<string, unknown> {
        let campaignCode;
        if (this.campaignCodes) {
            campaignCode = Object.values(this.campaignCodes);
        }
        let promotionCode;
        if (this.promotionCodes) {
            promotionCode = Object.values(this.promotionCodes);
        }
        return {
            fromOrderDate: this.fromDate,
            toOrderDate: this.toDate,
            campaignCodes: campaignCode?.map(x => x.value) || [],
            promotionCodes: promotionCode?.map(x => x.value) || []
        };
    }

    search(fromDate: string, toDate: string): void {
        this.fromDate = fromDate;
        this.toDate = toDate;

        if (this.gridOptions.api) {
            this.gridOptions.api.setDatasource(this.dataSource);
        }
    }

    clear(): void {
        this.campaignCodes = null;
        this.promotionCodes = null;
    }

    async getAdvantageCampaignPromotionItems(
        campaignCodes: string[]
    ): Promise<void> {
        const url = "/api/Advantage/Promotion/Items";

        await this.restClient
            .postJson<ISelectListItem[]>(url, campaignCodes)
            .then(response => {
                if (response.data) {
                    const items =
                        response.data.map(c => ({
                            text: `${c.text}`,
                            value: c.value
                        })) ?? [];
                    this.promotionOptions = items;
                }
            });
    }

    async getAdvantageCampaignItems(): Promise<void> {
        await this.restClient
            .getJson<ISelectListItem[]>("/api/Advantage/Campaign/Items")
            .then(response => {
                const items =
                    response.data?.map(c => ({
                        text: `${c.text}`,
                        value: c.value
                    })) ?? [];
                this.campaignOptions = items;
            });
    }

    @Watch("campaignCodes")
    campaignCodeChanged() {
        if (this.campaignCodes) {
            const campaignCode = Object.values(this.campaignCodes);
            this.getAdvantageCampaignPromotionItems(
                campaignCode.map(x => x.value || "")
            );
        } else {
            this.promotionCodes = null;
        }
    }
}
